import { render, staticRenderFns } from "./CompanyBehindForm.vue?vue&type=template&id=c5a07dea&"
import script from "./CompanyBehindForm.vue?vue&type=script&lang=js&"
export * from "./CompanyBehindForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports